import { jsx as _jsx } from "react/jsx-runtime";
import chevronDownIcon from '@/core/svg/fa/chevron-down.svg';
import { SvgIcon } from '../SvgIcon';
import { ButtonStyled } from './DropdownButton.styled';
const DropdownButton = (props) => {
    return _jsx(ButtonStyled, { variant: "outlined", ...props, endIcon: _jsx(SvgIcon, { icon: chevronDownIcon, size: "3xs" }) });
};
export { DropdownButton };
